import type { Category } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import { gql, useMutation } from '@apollo/client'

export interface CategoryInfoInput {
  id?: GQL_ID
  name: string
  status?: number
  icon_id?: GQL_ID
  alternative_icon_id?: GQL_ID
  mini_icon_id?: GQL_ID
  customer_order?: number
  assembler_order?: number
  slug?: string
  featured?: boolean
  preview_size?: string
}

export interface SaveCategory {
  category: Category
}

export interface SaveCategoryVariables {
  categoryInfo: CategoryInfoInput
}

export const GQL_MUTATION_SAVE_CATEGORY = gql`
  mutation saveCategory ($categoryInfo: CategoryInfoInput!) {
    category: saveCategory(categoryInfo: $categoryInfo) {
      id
      name
      status
      featured
      slug
      customer_order
      assembler_order

      icon_id
      icon {
        url
      }

      alternative_icon_id
      altIcon {
        url
      }

      mini_icon_id
      miniIcon {
        url
      }

      parent {
        id
        name
      }

      i18n {
        language_code
        name
      }
    }
  }
`

export const useMutateSaveCategory = () => {
  return useMutation<SaveCategory, SaveCategoryVariables>(
    GQL_MUTATION_SAVE_CATEGORY
  )
}
